import { ClientTypeEnum } from './client-type-enum';

/**
 * Type de client défini au niveau d'angular.json
 * Celui ci change selon l'appli appelée (mode mobile / web)
 * Par défaut --> type WEB
 */
export const client = {
    type: ClientTypeEnum.WEB
}